<app-modal
  [title]="'Usuń wpisy'"
  [confirmLabel]="'Usuń'"
  [showConfirm]="true"
  [showCancel]="true"
  [onConfirmAction]="deleteRow.bind(this)"
>
  <p>
    Na pewno chcesz usunąć wpisy z całego tygodnia dla
    <b>{{ row?.workItemName }}</b>
    ?
  </p>
  <br />
  <p class="text-red-600">
    <strong>Operacji nie będzie można cofnąć.</strong>
  </p>
</app-modal>
